<template>
  <v-list class="mt-5">
    <v-list-item :to="`${base}/activities`" ripple>
      <v-list-item-icon>
        <v-icon>mdi-eye-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>{{ $t("admin.menu.teamAdmin.activities") }}</v-list-item-title>
    </v-list-item>
    <v-list-group no-action prepend-icon="mdi-cog-outline" value="true">
      <template v-slot:activator>
        <v-list-item-title>{{ $t("admin.menu.teamAdmin.settings") }}</v-list-item-title>
      </template>
      <v-list-item :to="`${base}/content`" link ripple>
        <v-list-item-title>{{ $t("admin.menu.teamAdmin.content") }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-comment-text</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item :to="`${base}/branding`" link ripple>
        <v-list-item-title>{{ $t("admin.menu.teamAdmin.branding") }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-palette</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item :to="`${base}/zoom`" link ripple>
        <v-list-item-title>{{ $t("admin.menu.teamAdmin.zoom") }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-video-account</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item :to="`${base}/advanced`" link ripple>
        <v-list-item-title>{{ $t("admin.menu.teamAdmin.advanced") }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-cogs</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>
<script>
export default {
  computed: {
    base() {
      return `/admin/team/${this.$route.params.teamId}`;
    },
  },
};
</script>
